// 📁 components/PublicProfile/SocialLinks.jsx
// Renders social media links.
import React from 'react';

const SocialLinks = ({ socialLinks }) => {
    return (
        <div className="profile-socials">
            {socialLinks?.twitter && (
                <a href={`https://twitter.com/${socialLinks.twitter}`} target="_blank" rel="noreferrer">🐦 Twitter</a>
            )}
            {socialLinks?.instagram && (
                <a href={`https://instagram.com/${socialLinks.instagram}`} target="_blank" rel="noreferrer">📸 Instagram</a>
            )}
            {socialLinks?.github && (
                <a href={`https://github.com/${socialLinks.github}`} target="_blank" rel="noreferrer">🐙 GitHub</a>
            )}
        </div>
    );
};

export default SocialLinks;